import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePageLanguage } from '../context/PageLanguageContext';
import logoImage from '../assets/logo.png';

const translations = {
  de: {
    title: 'Rink Hockey Scoreboard',
    desktop: 'Desktop Edition',
    pricing: 'Preise',
    manual: 'Handbuch',
    videos: 'Videoanleitungen',
    changelog: 'Changelog',
    open: 'Scoreboard starten',
    language: 'Sprache',
  },
  en: {
    title: 'Rink Hockey Scoreboard',
    desktop: 'Desktop Edition',
    pricing: 'Pricing',
    manual: 'Manual',
    videos: 'Video Guides',
    changelog: 'Changelog',
    open: 'Open scoreboard',
    language: 'Language',
  }
};

export default function HeaderSection({ lang, setLang }) {
  const navigate = useNavigate();
  const { pageLanguage, setPageLanguage } = usePageLanguage();
  
  // Use pageLanguage from context if available, otherwise fall back to prop (for HomePage)
  const currentLang = pageLanguage || lang || 'de';
  const t = translations[currentLang];

  const handleLanguageChange = (nextLang) => {
    if (setLang) {
      setLang(nextLang);
    } else {
      setPageLanguage(nextLang);
    }
  };
  
  return (
    <div className="flex justify-between items-center p-4">
      <div 
        className="flex items-center gap-2 text-base text-stone-900 cursor-pointer hover:opacity-80 transition-opacity"
        onClick={() => navigate('/')}
      >
        <img
          loading="lazy"
          src={logoImage}
          alt="Rink Hockey Logo"
          className="w-8 h-8 object-contain"
        />
        <span>{t.title}</span>
      </div>
      <div className="flex flex-wrap items-center justify-end gap-2 md:gap-4">
        {/* Language Switcher */}
        <div className="flex items-center rounded-lg bg-gray-100 p-1">
          <button
            type="button"
            onClick={() => handleLanguageChange('de')}
            className={`px-4 py-2 rounded-md text-sm transition-colors ${
              currentLang === 'de'
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            }`}
            aria-label={t.language}
          >
            DE
          </button>
          <button
            type="button"
            onClick={() => handleLanguageChange('en')}
            className={`px-4 py-2 rounded-md text-sm transition-colors ${
              currentLang === 'en'
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            }`}
            aria-label={t.language}
          >
            EN
          </button>
        </div>
        {/* Editions first: what the product IS comes before how to operate it. */}
        <button
          className="flex items-center px-4 py-2 text-gray-900 font-medium hover:text-blue-600 transition-colors rounded-lg text-sm"
          onClick={() => navigate('/desktop')}
        >
          {t.desktop}
        </button>
        <button
          className="flex items-center px-4 py-2 text-gray-900 font-medium hover:text-blue-600 transition-colors rounded-lg text-sm"
          onClick={() => navigate('/preise')}
        >
          {t.pricing}
        </button>
        <span className="h-5 w-px bg-gray-200" aria-hidden="true" />
        <button 
          className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors rounded-lg text-sm"
          onClick={() => navigate('/manual')}
        >
          {t.manual}
        </button>
        <button 
          className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors rounded-lg text-sm"
          onClick={() => navigate('/videos')}
        >
          {t.videos}
        </button>
        <button 
          className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors rounded-lg text-sm"
          onClick={() => navigate('/changelog')}
        >
          {t.changelog}
        </button>
        <button 
          className="flex items-center px-5 py-3 bg-red-500 hover:bg-red-600 transition-colors text-white rounded-lg text-sm"
          onClick={() => navigate('/control')}
        >
          {t.open}
        </button>
      </div>
    </div>
  );
}